// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Lien torrent cliquable */
.torrent-link {
    color: var(--primary-color);
    text-decoration: none;
    font-weight: 500;
}

.torrent-link:hover {
    text-decoration: underline;
}

.torrent-log {
    .torrent-title {
        width: 50%;
        a {
            text-decoration: none;
        }
    }
}

.search-input {
    padding: 10px 14px;
    border-radius: 8px;
    border: 1px solid var(--border-color);
    background: var(--card-bg);
    color: var(--text-color);
    width: 250px;
    padding-right: 48px; /* space for clear button */
    transition: 0.2s;
}

.search-input:focus {
    outline: none;
    border-color: var(--primary-color);
}

.results-count {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    color: var(--text-color);
    opacity: 0.8;
}

.red-timer {
    color: #f60c0c;
    font-weight: 600;
}

.no-results-row td {
    text-align: center;
    padding: 25px 0;
    font-size: 16px;
    color: var(--text-color);
    opacity: 0.7;
}

.no-results {
    text-align: center;
}

.site-badge {
    padding: 6px 12px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    color: white;
    display: inline-block;
    text-transform: capitalize;
}

/* Couleurs */
.badge-blue {
    background: #3498db;
}

.badge-orange {
    background: #e67e22;
}

.badge-purple {
    background: #9b59b6;
}

.badge-green {
    background: #2ecc71;
}

.badge-default {
    background: #7f8c8d;
}

/* Requested torrent styling */
.requested-row {
    background: rgba(149, 165, 166, 0.06); /* subtle grey */
    border-left: 4px solid var(--primary-color);
}

.requested-badge {
    display: inline-block;
    background: transparent; /* épuré */
    color: var(--primary-color);
    padding: 2px 8px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 500;
    margin-right: 8px;
    border: 1px solid rgba(0,0,0,0.08);
    box-shadow: none;
}

.title-badge {
    margin-right: 12px;
    vertical-align: middle;
    border-color: var(--primary-color);
    color: var(--primary-color);
}

/* Search wrapper + clear button */
.search-wrapper {
    position: relative;
    display: inline-block;
}

.search-clear {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    border: none;
    background: transparent;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: var(--text-color);
    opacity: 0.6;
    transition: 0.12s ease;
    font-size: 12px;
}

.search-clear:hover { opacity: 1; background: rgba(0,0,0,0.06); }
.search-clear:focus, .search-clear:active, .search-clear:focus-visible { outline: none; box-shadow: none; }
.search-clear::-moz-focus-inner { border: 0; }

/* Requested filter button (dans la search-wrapper) */
.requested-filter {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    vertical-align: middle;
    margin-left: 4px;
    border: 1px solid var(--primary-color);
    background: transparent;
    color: var(--primary-color);
    padding: 4px 10px;
    min-height: 28px;
    border-radius: 999px;
    cursor: pointer;
    font-weight: 600;
    font-size: 13px;
    transition: background 0.12s ease, color 0.12s ease, transform 0.06s ease;
}

.requested-filter:hover {
    background: rgba(0,0,0,0.03);
}

.requested-filter.active {
    background: var(--primary-color);
    color: #ffffff;
    border-color: var(--primary-color);
    border-width: 2px;
    padding: 4px 12px; /* slightly wider when active */
    transform: scale(1.04);
    font-weight: 700;
    box-shadow: 0 10px 30px rgba(0,0,0,0.10);
}

.requested-filter:focus {
    outline: none;
    box-shadow: 0 0 0 4px rgba(89,133,128,0.12);
}

.requested-filter.active::before {
    content: "\\2713"; /* check mark */
    display: inline-block;
    margin-right: 6px;
    font-weight: 700;
    font-size: 12px;
}

`, "",{"version":3,"sources":["webpack://./src/styles/Torrent.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;IACI,2BAA2B;IAC3B,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI;QACI,UAAU;QACV;YACI,qBAAqB;QACzB;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,qCAAqC;IACrC,0BAA0B;IAC1B,wBAAwB;IACxB,YAAY;IACZ,mBAAmB,EAAE,2BAA2B;IAChD,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,wBAAwB;IACxB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,wBAAwB;IACxB,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,0BAA0B;AAC9B;;AAEA,aAAa;AACb;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,8BAA8B;AAC9B;IACI,qCAAqC,EAAE,gBAAgB;IACvD,2CAA2C;AAC/C;;AAEA;IACI,qBAAqB;IACrB,uBAAuB,EAAE,UAAU;IACnC,2BAA2B;IAC3B,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kCAAkC;IAClC,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,kCAAkC;IAClC,2BAA2B;AAC/B;;AAEA,kCAAkC;AAClC;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,YAAY;IACZ,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,wBAAwB;IACxB,YAAY;IACZ,sBAAsB;IACtB,eAAe;AACnB;;AAEA,sBAAsB,UAAU,EAAE,4BAA4B,EAAE;AAChE,yEAAyE,aAAa,EAAE,gBAAgB,EAAE;AAC1G,kCAAkC,SAAS,EAAE;;AAE7C,qDAAqD;AACrD;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,sBAAsB;IACtB,gBAAgB;IAChB,sCAAsC;IACtC,uBAAuB;IACvB,2BAA2B;IAC3B,iBAAiB;IACjB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yEAAyE;AAC7E;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gCAAgC;IAChC,cAAc;IACd,kCAAkC;IAClC,iBAAiB;IACjB,iBAAiB,EAAE,+BAA+B;IAClD,sBAAsB;IACtB,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,2CAA2C;AAC/C;;AAEA;IACI,gBAAgB,EAAE,eAAe;IACjC,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB","sourcesContent":["/* Lien torrent cliquable */\r\n.torrent-link {\r\n    color: var(--primary-color);\r\n    text-decoration: none;\r\n    font-weight: 500;\r\n}\r\n\r\n.torrent-link:hover {\r\n    text-decoration: underline;\r\n}\r\n\r\n.torrent-log {\r\n    .torrent-title {\r\n        width: 50%;\r\n        a {\r\n            text-decoration: none;\r\n        }\r\n    }\r\n}\r\n\r\n.search-input {\r\n    padding: 10px 14px;\r\n    border-radius: 8px;\r\n    border: 1px solid var(--border-color);\r\n    background: var(--card-bg);\r\n    color: var(--text-color);\r\n    width: 250px;\r\n    padding-right: 48px; /* space for clear button */\r\n    transition: 0.2s;\r\n}\r\n\r\n.search-input:focus {\r\n    outline: none;\r\n    border-color: var(--primary-color);\r\n}\r\n\r\n.results-count {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-size: 15px;\r\n    color: var(--text-color);\r\n    opacity: 0.8;\r\n}\r\n\r\n.red-timer {\r\n    color: #f60c0c;\r\n    font-weight: 600;\r\n}\r\n\r\n.no-results-row td {\r\n    text-align: center;\r\n    padding: 25px 0;\r\n    font-size: 16px;\r\n    color: var(--text-color);\r\n    opacity: 0.7;\r\n}\r\n\r\n.no-results {\r\n    text-align: center;\r\n}\r\n\r\n.site-badge {\r\n    padding: 6px 12px;\r\n    border-radius: 8px;\r\n    font-size: 13px;\r\n    font-weight: 600;\r\n    color: white;\r\n    display: inline-block;\r\n    text-transform: capitalize;\r\n}\r\n\r\n/* Couleurs */\r\n.badge-blue {\r\n    background: #3498db;\r\n}\r\n\r\n.badge-orange {\r\n    background: #e67e22;\r\n}\r\n\r\n.badge-purple {\r\n    background: #9b59b6;\r\n}\r\n\r\n.badge-green {\r\n    background: #2ecc71;\r\n}\r\n\r\n.badge-default {\r\n    background: #7f8c8d;\r\n}\r\n\r\n/* Requested torrent styling */\r\n.requested-row {\r\n    background: rgba(149, 165, 166, 0.06); /* subtle grey */\r\n    border-left: 4px solid var(--primary-color);\r\n}\r\n\r\n.requested-badge {\r\n    display: inline-block;\r\n    background: transparent; /* épuré */\r\n    color: var(--primary-color);\r\n    padding: 2px 8px;\r\n    border-radius: 6px;\r\n    font-size: 12px;\r\n    font-weight: 500;\r\n    margin-right: 8px;\r\n    border: 1px solid rgba(0,0,0,0.08);\r\n    box-shadow: none;\r\n}\r\n\r\n.title-badge {\r\n    margin-right: 12px;\r\n    vertical-align: middle;\r\n    border-color: var(--primary-color);\r\n    color: var(--primary-color);\r\n}\r\n\r\n/* Search wrapper + clear button */\r\n.search-wrapper {\r\n    position: relative;\r\n    display: inline-block;\r\n}\r\n\r\n.search-clear {\r\n    position: absolute;\r\n    right: 12px;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    border: none;\r\n    background: transparent;\r\n    width: 28px;\r\n    height: 28px;\r\n    border-radius: 50%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    color: var(--text-color);\r\n    opacity: 0.6;\r\n    transition: 0.12s ease;\r\n    font-size: 12px;\r\n}\r\n\r\n.search-clear:hover { opacity: 1; background: rgba(0,0,0,0.06); }\r\n.search-clear:focus, .search-clear:active, .search-clear:focus-visible { outline: none; box-shadow: none; }\r\n.search-clear::-moz-focus-inner { border: 0; }\r\n\r\n/* Requested filter button (dans la search-wrapper) */\r\n.requested-filter {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n    vertical-align: middle;\r\n    margin-left: 4px;\r\n    border: 1px solid var(--primary-color);\r\n    background: transparent;\r\n    color: var(--primary-color);\r\n    padding: 4px 10px;\r\n    min-height: 28px;\r\n    border-radius: 999px;\r\n    cursor: pointer;\r\n    font-weight: 600;\r\n    font-size: 13px;\r\n    transition: background 0.12s ease, color 0.12s ease, transform 0.06s ease;\r\n}\r\n\r\n.requested-filter:hover {\r\n    background: rgba(0,0,0,0.03);\r\n}\r\n\r\n.requested-filter.active {\r\n    background: var(--primary-color);\r\n    color: #ffffff;\r\n    border-color: var(--primary-color);\r\n    border-width: 2px;\r\n    padding: 4px 12px; /* slightly wider when active */\r\n    transform: scale(1.04);\r\n    font-weight: 700;\r\n    box-shadow: 0 10px 30px rgba(0,0,0,0.10);\r\n}\r\n\r\n.requested-filter:focus {\r\n    outline: none;\r\n    box-shadow: 0 0 0 4px rgba(89,133,128,0.12);\r\n}\r\n\r\n.requested-filter.active::before {\r\n    content: \"\\2713\"; /* check mark */\r\n    display: inline-block;\r\n    margin-right: 6px;\r\n    font-weight: 700;\r\n    font-size: 12px;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
